import { InfoDialogData } from '../../shared/info-dialog/info-dialog.interface';

export const ASSET_MAINTENANCE_SCHEDULES_FLAGS_LEGEND: InfoDialogData = {
  title: 'Maintenance Schedule Flags',

  paragraphs: [
    'Flags provide a quick overview of important Maintenance Schedule settings.',
    'Only flags that apply to a Maintenance Schedule are displayed in the list.'
  ],

  items: [
    {
      id: 'schedule-enabled',
      icon: 'power_settings_new',
      iconClass: 'info-icon-yellow',
      label: 'Schedule Enabled',
      description: 'Indicates that the Maintenance Schedule is enabled.'
    },
    {
      id: 'recurring-schedule',
      icon: 'repeat',
      iconClass: 'info-icon-blue',
      label: 'Recurring Schedule',
      description:
        'Indicates that the Maintenance Schedule repeats according to its configured recurrence settings.'
    },
    {
      id: 'auto-create',
      icon: 'note_add',
      iconClass: 'info-icon-green',
      label: 'Automatically Creates Maintenance Records',
      description:
        'Indicates that Maintenance Records are automatically created when the configured Auto Create Date is reached.'
    }
  ],

  alert: {
    type: 'info',
    icon: 'info',
    message:
      'Automatic creation of Maintenance Records depends on the Maintenance Schedule being enabled.'
  }
};
